import styled from "styled-components";
import { Input } from "antd";
import { theme } from "../../../config";
const { TextArea } = Input;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
`;

export const MentionInputWrapper = styled.div`
  position: relative;

  .mentions {
    background-color: #fff;
  }

  .mentions--singleLine .mentions__control {
    display: inline-block;
    width: 130px;
  }
  .mentions--singleLine .mentions__highlighter {
    padding: 1px;
    border: 2px inset transparent;
  }
  .mentions--singleLine .mentions__input {
    padding: 1px;
    border: 2px inset;
  }

  .mentions--multiLine .mentions__control {
    border: 1px solid #8e8c8c;
    border: 1px solid #8e8c8c;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 14px;
  }
  .mentions--multiLine .mentions__highlighter {
    border: 1px solid transparent;
    padding: 4px 11px;
    padding-right: 40px;
    min-height: 100px;
    word-break: break-all;
  }
  .mentions--multiLine .mentions__input {
    border: 1px solid silver;
    padding: 4px 11px;
    padding-right: 40px;
    outline: 0;
    border: 1px solid #8e8c8c;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 14px;
  }

  .mentions__input {
    &:hover,
    &:focus,
    &:hover:disabled {
      border: 1px solid ${theme.colors.secondary};
    }
  }

  .mentions__suggestions__list {
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.15);
    font-size: 14px;
    box-shadow: 0px 0px 10px 5px #00000026;
  }

  .mentions__suggestions__item {
    padding: 5px 15px;
    color: #262626;
  }

  .mentions__suggestions__item--focused {
    background-color: #1877f233;
  }

  .mentions__mention {
    background-color: #1877f233;
    pointer-events: none;
  }

 
`;

export const InputComment = styled(TextArea)`
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
  &${theme.hideScrollbar}
  padding-right: 40px;
  font-size: 16px;

  ${theme.defaultInputStyle}

  &:focus ~ .sendIcon {
    color: #00918E;
  }
`;

export const SendIconContainer = styled.div`
  position: absolute;
  margin: 10px 0 0 -50px;
  height: 30px;
  cursor: pointer;
  top: 0;
  right: 10px;
`;

export const DateTime = styled.span`
  color: ${theme.colors.gray3};
  font-family: "Orkney Light";
  font-size: 12px;
  line-height: 18px;
`;

export const InputArea = styled.div`
  margin-bottom: 20px;
  position: sticky;
  top: 0;
`;
export const Header = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  padding: 19px 0 16px 0;
  background: ${theme.colors.white};
  font-family: "Orkney Bold";
  color: ${theme.colors.custom.darkblue3};
`;
export const CommentWrapper = styled.div`
  padding: 8px;
  margin-top: 10px;
  &:hover {
    background: ${theme.colors.neutral.black8};
    transition: 0.3s;
  }
`;

export const CommentsWrapper = styled.div`
  height: 200px;
  overflow: auto;
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

export const AttachFileWrapper = styled.div`
  margin: 18px 0;
`;

export const InputDocumentWrapper = styled.input`
  display: none;
`;